import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const HelpButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { currentUser } = useAuth();

  // Only render if there's a currentUser
  if (!currentUser) return null;

  return (
    <div 
      className="max-sm:hidden fixed bottom-4 left-4 flex items-center gap-2 z-50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="bg-white rounded-full p-2 shadow-lg cursor-help">
        <HelpCircle className="w-6 h-6 text-gray-600" />
      </div>
      
      <div className={`
        bg-white rounded-lg shadow-lg p-3 text-sm text-gray-600
        transition-all duration-200 origin-left
        ${isHovered ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
      `}>
        Please send any questions, comments, or concerns to Aidan Young
      </div>
    </div>
  );
};

export default HelpButton;